<template>
  <restaurant-form />
</template>

<script>
import RestaurantForm from '@/components/forms/RestaurantForm'
export default {
  components: {
    RestaurantForm
  }
}
</script>
